module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/news-article-2c88389f0b153ee85d596427130903df.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/news-article.svg
// module id = hgH4
// module chunks = 24